// src/components/HolidayOverlay.jsx

import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import translations from './translations.json';
import './css/holidayOverlay.css';

// Image URLs for each holiday
const DRESS_IMG_CHRISTMAS      = 'https://static.reservaties.net/guide/dress_red_extra_small.webp';
const BACKGROUND_IMG_CHRISTMAS = 'https://static.reservaties.net/guide/christmas.webp';

const DRESS_IMG_EASTER         = 'https://static.reservaties.net/guide/dress_easter_extra_small.webp';
const BACKGROUND_IMG_EASTER    = 'https://static.reservaties.net/guide/easter.webp';

const DRESS_IMG_VALENTINE      = 'https://static.reservaties.net/guide/dress_ribbon_extra_small.webp';
const BACKGROUND_IMG_VALENTINE = 'https://static.reservaties.net/guide/valentine.webp';

// Static per-year Easter dates (hard-coded)
const EASTER_DATES = {
  '2025': '04/20',
  '2026': '04/05',
  '2027': '28/03',
  '2028': '16/04',
};

const HOLIDAYS = {
  christmas: {
    date: '12/25',
    dressImg:      DRESS_IMG_CHRISTMAS,
    backgroundImg: BACKGROUND_IMG_CHRISTMAS,
  },
  easter: {
    dateKey: 'easter',
    dressImg:      DRESS_IMG_EASTER,
    backgroundImg: BACKGROUND_IMG_EASTER,
  },
  valentine: {
    date: '02/14',
    dressImg:      DRESS_IMG_VALENTINE,
    backgroundImg: BACKGROUND_IMG_VALENTINE,
  },
};

const HolidayOverlay = () => {
  const locale = localStorage.getItem('preferredLanguage') || 'nl';
  const t = translations[locale].holidayOverlay;

  const [visible, setVisible]           = useState(false);
  const [showDiscount, setShowDiscount] = useState(false);
  const [currentHolidayKey, setCurrentHolidayKey] = useState(null);

  const todayMMDD = () => format(new Date(), 'MM/dd');
  const thisYear  = () => format(new Date(), 'yyyy');

  const findHolidayKey = () => {
    const today = todayMMDD();
    const year  = thisYear();
    for (const key of Object.keys(HOLIDAYS)) {
      const cfg = HOLIDAYS[key];
      const dateString = key === 'easter'
        ? EASTER_DATES[year]
        : cfg.date;
      if (dateString === today) {
        return key;
      }
    }
    return null;
  };

  useEffect(() => {
    const key = findHolidayKey();
    if (!key) return;
    const storageKey = `${key}${thisYear()}`;
    if (localStorage.getItem(storageKey)) return;
    setCurrentHolidayKey(key);
    setVisible(true);
  }, []);

  const closeOverlay = () => {
    if (currentHolidayKey) {
      const storageKey = `${currentHolidayKey}${thisYear()}`;
      localStorage.setItem(storageKey, 'true');
    }
    setVisible(false);
  };

  const handleYesClick = (e) => {
    e.stopPropagation();
    window.location.hash = '/mateza-cloud-apps';
    closeOverlay();
  };

  const handleNoClick = (e) => {
    e.stopPropagation();
    closeOverlay();
  };

  if (!visible || !currentHolidayKey) return null;

  const { dressImg, backgroundImg } = HOLIDAYS[currentHolidayKey];
  const content = t.holidays[currentHolidayKey];

  return (
    <div className="holiday-discount-component">
      <div
        className="holiday-overlay"
        style={{ backgroundImage: `url(${backgroundImg})` }}
        onClick={closeOverlay}
      >
        <div className="holiday-content">
          <div className="tutorial-desc-card holiday-text-box">
            {!showDiscount ? (
              <>
                <div className="holiday-title">{content.initialTitle}</div>
                <div
                  className="tutorial-description holiday-description"
                  dangerouslySetInnerHTML={{ __html: content.initialDescription }}
                />
                <div className="tutorial-button-group">
                  <button className="button-style-3" onClick={handleYesClick}>
                    {t.btnYes}
                  </button>
                  <button className="no-button" onClick={handleNoClick}>
                    {t.btnNo}
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="holiday-title">{content.discountTitle}</div>
                <div
                  className="tutorial-description holiday-description"
                  dangerouslySetInnerHTML={{ __html: content.discountDescription }}
                />
                <div className="tutorial-button-group">
                  <button className="tutorial-button" onClick={closeOverlay}>
                    {t.btnClose}
                  </button>
                </div>
              </>
            )}
          </div>
          <div className="holiday-dress-container">
            <img src={dressImg} alt="" className="holiday-dress" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HolidayOverlay;
